module.exports = __webpack_public_path__ + "static/office_image_1-5c3e0a15508fdbd979d0d384fe278ed8.webp";